import config from '@frolight/config';
import HTTPStatusError from '@frolight/utils/HTTPStatusError';

const ROOT_URL = `${config.api.uri}/user`;

const PREFERENCES_URL = `${ROOT_URL}/preferences`;

export const getPreferences = async (abortController, accessToken) => {
  try {
    const response = await fetch(PREFERENCES_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`
      },
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const rawData = await response.json();
    const data = rawData.data;
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      if (err instanceof HTTPStatusError) {
        throw err;
      } else {
        throw new Error(`Error getting preferences for authenticated user: ${err.message}`);
      }
    }
  }
};

export const patchPreferences = async (abortController, accessToken, newPreferences) => {
  try {
    const response = await fetch(PREFERENCES_URL, {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Authorization': `${accessToken.type} ${accessToken.token}`,
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(newPreferences),
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      if (err instanceof HTTPStatusError) {
        throw err;
      } else {
        throw new Error(`Error updating user preferences: ${err.message}`);
      }
    }
  }
};
